import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import MainLayout from '@/layouts/MainLayout';
import DashboardPage from '@/components/dashboard/DashboardPage';
import MattersPage from '@/pages/MattersPage';
import SettingsProfilePage from '@/pages/SettingsProfilePage';
import TasksV5HomePage from '@/pages/tasks-v5/TasksV5HomePage';
import AuthContinuePage from '@/pages/AuthContinuePage';
import IdeasKitchenV1Page from '@/pages/ideas-kitchen/index.jsx';
import IntelligenceStudioV1Page from '@/pages/intelligence-studio/index.jsx';
import { tenantLegacyRouteManifest } from '@/routes/tenantLegacyRouteManifest';

function LegacyTenantPage({ source }: { source: string }) {
  return (
    <main style={{ fontFamily: 'Inter, sans-serif', padding: '24px' }}>
      <h1>This module is currently undergoing an enterprise upgrade.</h1>
      <p>Please check back in the next sprint window.</p>
      <code>{source}</code>
    </main>
  );
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/auth/continue" element={<AuthContinuePage />} />
      <Route element={<MainLayout />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/matters" element={<MattersPage />} />
        <Route path="/tasks" element={<TasksV5HomePage />} />
        <Route path="/intelligence-studio" element={<IntelligenceStudioV1Page />} />
        <Route path="/ideas-kitchen" element={<IdeasKitchenV1Page />} />
        <Route path="/settings/profile" element={<SettingsProfilePage />} />
        {tenantLegacyRouteManifest.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<LegacyTenantPage source={route.source} />}
          />
        ))}
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
